import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BaseService } from "@app/shared/services/base.service";
import { ERROR_SENDING_REQUEST } from "@app/shared/services/display.messages";
import { FlightService } from "@app/shared/services/flight.service";
import { NavigationService } from "@app/shared/services/navigation.service";
import { ShareVars } from "@app/shared/services/share.vars";

@Component({
    selector: "app-edit-flight-reservation",
    templateUrl: "./edit-flight-reservation.component.html",
    styleUrls: ["./edit-flight-reservation.component.scss"],
})
export class EditFlightReservationComponent implements OnInit {

	showFlightBookingDeliveryModal = false;
	isSubmitting: boolean = false;
	pnr: string = "";
	name: string = "";
    formData = {
        changeType: "",
        details: "",
    };

	typeList = [
		{ value: "modification", label: "MODIFICATION_DEMAND" },
		{ value: "cancellation", label: "CANCELLATION_DEMAND" },
		{ value: "information", label: "INFORMATION_DEMAND" },
		{ value: "baggage", label: "BAGGAGE_DEMAND" },
	];

    constructor(
		private flightService: FlightService,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private baseService: BaseService
	) {}

    ngOnInit() {
		this.pnr = this.route.snapshot.queryParams['pnr'];
		this.name = this.route.snapshot.queryParams['name'];
		//if (!this.pnr || !this.name) {
		//	this.navigationService.goToHomePage();
		//}
		ShareVars.isBusy = false;
	}

    onSubmit(form: any) {
		if (this.isSubmitting) return;
        if (form.valid) {
			this.isSubmitting = true;
			const requestPayload = {
				type: this.formData.changeType,
				details: this.formData.details,
				pnr: this.pnr,
				name: this.name
			};
			this.flightService.sendFlightModificationRequest(requestPayload).subscribe(
				(response) => {
					if (response && response.success){
						this.showFlightBookingDeliveryModal = true
					}else{
						ShareVars.showError = true;
						ShareVars.errorMessage = ERROR_SENDING_REQUEST;
					}
					this.isSubmitting = false;
				},
				(error) => {
					ShareVars.showError = true;
					ShareVars.errorMessage = ERROR_SENDING_REQUEST;
					this.isSubmitting = false;
				}
			);
        }
    }

	goBack(){
		this.showFlightBookingDeliveryModal = false;
		this.navigationService.goToHomePage();
	}

	isArabic() {
		return this.baseService.isArabic();
	}
}
